import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Flex,
  List,
  Modal,
  Radio,
  Button,
  useToast,
  ListItem,
  ModalBody,
  FormLabel,
  RadioGroup,
  ModalFooter,
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import FormikSelect from "components/formikSelect";
import useGetCharities from "api/queries/useGetCharities";

const RequestModal = ({ isOpen, onClose }) => {
  const toast = useToast();
  const navigate = useNavigate();
  const [isDonateToCharity, setIsDonateToCharity] = useState(true);
  const [isAutoDiscounted, setIsAutoDiscounted] = useState(true);

  const charityQuery = useGetCharities();
  const charities = charityQuery?.data?.data || [];

  const formik = useFormik({
    initialValues: {
      rejected_item_action: isDonateToCharity
        ? "Donate to charity"
        : "Returned",
      discount: isAutoDiscounted,
      charity: null,
    },
    onSubmit: (values) => {
      navigate("/register", {
        state: {
          rejected_item_action: values.rejected_item_action,
          discount: values.discount,
          charity: values.charity,
        },
      });
      onClose();
    },
  });

  useEffect(() => {
    formik.setFieldValue("charity", charities[0]?._id);
  }, [charityQuery?.data?.data]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <ModalOverlay />
      <ModalContent
        minH={"300px"}
        minW={"900px"}
        p={4}
        py={5}
        borderRadius={"16px"}
      >
        <ModalBody display={"flex"} flexDirection={"column"} gap={6}>
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansSemiBold"
              fontSize={"16px"}
              lineHeight={"22px"}
              textTransform={"capitalize"}
              mb={2}
            >
              Rejected Items
            </Text>
            <Box
              border="1px solid #D9D9D9"
              borderRadius="8px"
              p={4}
              display={"flex"}
              flexDirection={"column"}
              gap={3}
            >
              <Flex direction={"column"} gap={2}>
                <Flex
                  flex={1}
                  justify={"space-between"}
                  alignItems={"center"}
                  mb={2}
                >
                  <Flex gap={2} alignItems={"center"}>
                    <FormLabel
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={12}
                      color={"#000000"}
                      margin={0}
                    >
                      What do you want us to do with your rejected items?
                    </FormLabel>
                  </Flex>
                  <RadioGroup
                    name={"rejected_item_status"}
                    value={
                      isDonateToCharity !== null
                        ? isDonateToCharity.toString()
                        : ""
                    }
                    onChange={(val) => {
                      setIsDonateToCharity(val === "true");
                      if (val === "false") {
                        formik.setFieldValue(
                          "rejected_item_action",
                          "Returned"
                        );
                        formik.setFieldValue("charity", null);
                      }
                    }}
                  >
                    <Flex>
                      <Radio
                        value="true"
                        fontFamily={"PlusJakartaSansMedium"}
                        fontSize={12}
                        mr={12}
                        color={"#000000"}
                      >
                        Donate to Charity
                      </Radio>
                      <Radio
                        value="false"
                        fontFamily={"PlusJakartaSansMedium"}
                        fontSize={12}
                        color={"#000000"}
                      >
                        Returned
                      </Radio>
                    </Flex>
                  </RadioGroup>
                </Flex>
                {isDonateToCharity ? (
                  <FormikSelect
                    formik={formik}
                    name="charity"
                    label="Select charity you wish to donate."
                    labelColor={"#000000"}
                    placeholder={"Select one........"}
                    defaultValue={charities[0]?._id}
                  >
                    {charities.map((charity) => (
                      <option key={charity._id} value={charity._id}>
                        {charity.name}
                      </option>
                    ))}
                  </FormikSelect>
                ) : (
                  <Box p={2} bg="#D9D9D966" borderRadius="4px" w="fit-content">
                    <List spacing={2} styleType="disc" pl={2}>
                      <ListItem
                        fontSize={"10px"}
                        fontFamily={"PlusJakartaSansRegular"}
                        color={"#444444"}
                        textTransform={"lowercase"}
                      >
                        We will charge £2.95 per item for rejected products.
                      </ListItem>
                    </List>
                  </Box>
                )}
              </Flex>
            </Box>
          </Box>
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansSemiBold"
              fontSize={"16px"}
              lineHeight={"22px"}
              textTransform={"capitalize"}
              mb={2}
            >
              Auto Discount
            </Text>
            <Box
              border="1px solid #D9D9D9"
              borderRadius="8px"
              p={4}
              display={"flex"}
              flexDirection={"column"}
              gap={3}
            >
              <Flex direction={"column"} gap={2}>
                <Flex
                  flex={1}
                  justify={"space-between"}
                  alignItems={"center"}
                  mb={2}
                >
                  <Flex gap={2} alignItems={"center"}>
                    <FormLabel
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={12}
                      color={"#000000"}
                      margin={0}
                    >
                      Would you like to have an automatic discount applied every
                      three months?
                    </FormLabel>
                  </Flex>
                  <RadioGroup
                    name={"rejected_item_status"}
                    value={
                      isAutoDiscounted !== null
                        ? isAutoDiscounted.toString()
                        : ""
                    }
                    onChange={(val) => {
                      setIsAutoDiscounted(val === "true");
                      if (val === "false") {
                        formik.setFieldValue("discount", false);
                      }
                      //   if (val === "false") {
                      //     onPreferItemNoteModalOpen();
                      //   }
                    }}
                  >
                    <Flex>
                      <Radio
                        value="true"
                        fontFamily={"PlusJakartaSansMedium"}
                        fontSize={12}
                        mr={16}
                        color={"#000000"}
                      >
                        Yes
                      </Radio>
                      <Radio
                        value="false"
                        fontFamily={"PlusJakartaSansMedium"}
                        fontSize={12}
                        color={"#000000"}
                      >
                        No
                      </Radio>
                    </Flex>
                  </RadioGroup>
                </Flex>
                <Box p={2} bg="#D9D9D966" borderRadius="4px" w="fit-content">
                  <List spacing={2} styleType="disc" pl={2}>
                    <ListItem
                      fontSize={"10px"}
                      fontFamily={"PlusJakartaSansRegular"}
                      color={"#444444"}
                      textTransform={"lowercase"}
                    >
                      To help sell items will be automatically reduced by 10%
                      every 3 month up to a maximum of 80% off RRP
                    </ListItem>
                  </List>
                </Box>
              </Flex>
            </Box>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flex w={"100%"} justify={"end"} gap={4}>
            <Button
              bg="#000000"
              borderRadius="12px"
              color="#FFFFFF"
              size="12px"
              fontFamily="PlusJakartaSansMedium"
              w={"200px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={formik.handleSubmit}
            >
              Save
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RequestModal;
